// src/features/auth/login/LoginForm.jsx
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { loginUser } from '../../../services/api';
import { useAuth } from '../../../context/AuthContext';
import { toast } from 'react-toastify';

const LoginForm = ({ setIsLoginView, closeModal }) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const { loginWithBackend } = useAuth();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const onSubmit = async (data) => {
        try {
            toast.info('Iniciando sesión...', { autoClose: 2000 });
            const result = await loginUser(data.email, data.password);

            // Set the authenticated user from backend response
            loginWithBackend(result.user, result.token);

            toast.success('¡Sesión iniciada correctamente!', {
                position: 'top-right',
                autoClose: 3000,
            });
            if (closeModal) closeModal();
            navigate('/dashboard');
        } catch (error) {
            toast.error(`Error: ${error.message}`, {
                position: 'top-right',
                autoClose: 5000,
            });
        }
    };

    return (
        <div className="p-6">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-4">
                    <label htmlFor="email" className="block text-sm font-medium text-surface-600 dark:text-surface-400 mb-1.5">
                        Correo electrónico
                    </label>
                    <input
                        id="email"
                        type="email"
                        placeholder="ejemplo@correo.com"
                        className="input-field"
                        {...register('email', {
                            required: 'El correo es obligatorio',
                            pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Correo no válido' },
                        })}
                    />
                    {errors.email && <span className="text-red-500 text-xs mt-1 block">{errors.email.message}</span>}
                </div>

                <div className="mb-4">
                    <label htmlFor="password" className="block text-sm font-medium text-surface-600 dark:text-surface-400 mb-1.5">
                        Contraseña
                    </label>
                    <div className="relative">
                        <input
                            id="password"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="••••••••"
                            className="input-field pr-11"
                            {...register('password', {
                                required: 'La contraseña es obligatoria',
                            })}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword((prev) => !prev)}
                            className="absolute inset-y-0 right-0 px-3 text-surface-500 hover:text-surface-700 dark:hover:text-surface-300 transition-colors"
                            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        >
                            {showPassword ? <FiEyeOff className="w-4 h-4" /> : <FiEye className="w-4 h-4" />}
                        </button>
                    </div>
                    {errors.password && <span className="text-red-500 text-xs mt-1 block">{errors.password.message}</span>}
                </div>

                <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center">
                        <input id="rememberMe" type="checkbox" className="w-4 h-4 text-brand-500 border-surface-300 dark:border-surface-600 rounded focus:ring-brand-500" />
                        <label htmlFor="rememberMe" className="ml-2 text-sm text-surface-500 dark:text-surface-400">Recuérdame</label>
                    </div>
                </div>

                <button type="submit" className="w-full btn-primary py-2.5 rounded-xl">
                    Iniciar Sesión
                </button>

                <p className="mt-4 text-center text-sm text-surface-500 dark:text-surface-400">
                    ¿No tienes una cuenta?{' '}
                    <span
                        className="text-brand-500 hover:text-brand-400 font-medium cursor-pointer transition-colors"
                        onClick={() => setIsLoginView()}
                    >
                        Regístrate
                    </span>
                </p>
            </form>
        </div>
    );
};

export default LoginForm;
